import { createGlobalStyle } from 'styled-components'
import { mediaMin } from 'styles/mediaQueries'

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  html, body {
    width: 100%;
    height: 100%;
    background: #fff;
  }
  body {
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  /* ----- Typography ----- */
  h1, h2, h3, h4, h5, h6, li {
    font-family: Raleway, sans-serif;
    font-style: normal;
    letter-spacing: .1rem;
  }
  
  p {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
  }
  
  
  a {
    &:link,
    &:active,
    &:focus,
    &:visited {
      color: #000;
    }
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  .section-title {
    font-size: 2rem;
    font-weight: 200;
    ${mediaMin.phoneLarge`
      font-size: 2.4rem;
    `}
    ${mediaMin.tablet`
      font-size: 2.8rem;
    `}
    ${mediaMin.tabletLandscape`
      font-size: 3.2rem;
    `}
  }

  .standard-paragraph {
    font-size: 1rem;
    ${mediaMin.tabletLandscape`
      font-size: 1.4rem;
    `}
  }

  .underline {
    text-decoration: underline;
  }

  .center {
    text-align: center;
  }

  /* ----- Modals ----- */
  .ReactModal__Overlay {
    opacity: 0;
    transition: opacity 200ms ease-in-out;
  }

  .ReactModal__Overlay--after-open {
    opacity: 1;
  }

  .ReactModal__Overlay--before-close {
    opacity: 0;
  }

  /* ----- Containers ----- */
  .container {
    width: 90%;
    margin: 0 auto;
    max-width: 1000px;
  }
  .team-container {
    width: 90%;
    margin: 0 auto;
    max-width: 800px;
  }
  .standard-padding {
    padding: 20px 0;
    ${mediaMin.tabletLandscape`
      padding: 100px 0;
    `}
  }

  .page.entering,
  .page.entered {
    pointer-events: auto;
  }
  .page.exiting {
    pointer-events: none;
  }
  
`

export default GlobalStyle
